<template>
  <div class="unload-add">
    <keep-alive>
      <edit/>
    </keep-alive>
  </div>
</template>
<script>
  import edit from './edit';

  export default {
    name: 'adminAddBillLadingUnloadPipe',
    components: {
      edit,
    },
    data() {
      return {
        start: true,
      };
    },
    watch: {
      // '$route.name': function() {
      //   this.start = false;
      //   this.$nextTick(() => {
      //     this.start = true;
      //   });
      // },
    },
  };
</script>
